import { CompanyUser } from '__generated__/GQL';
import { kycToStatus } from 'features/Bento/libs/mappings';

import { VerificationStatus } from '../../Verification/lib/steps/types';

interface GetAddressStatusProps {
  companyUser: Pick<CompanyUser, 'kycAddressStatus' | 'isAllowedToSkipPOA'>;
}

const getAddressStatus = ({ companyUser }: GetAddressStatusProps) => {
  if (companyUser.isAllowedToSkipPOA) {
    return VerificationStatus.Irrelevant;
  }

  return kycToStatus(companyUser.kycAddressStatus);
};

export default getAddressStatus;
